import { MetaOption } from './meta-option'
import { Injectable } from '@angular/core'

@Injectable()
export class MetaOptionSerializer {
  fromJson(json: any): MetaOption {
    const metaOption = json

    return metaOption
  }

  toJson(metaOption: MetaOption): any {
    return {
      ...metaOption
    }
  }
}
